import type { AxiosInstance, AxiosResponse } from 'axios';
import type { IApiMessageResponse } from '@/services/api/message/types';
import type { IApiResponse } from '@/services';
import type { IMessageData } from '@/entities';
import { mapApiMessage } from '@/mappers';

export * from './types';

export class ApiMessageEndpoint {
  axios: AxiosInstance;

  constructor(axiosInstance: AxiosInstance) {
    this.axios = axiosInstance;
  }

  async fetchMessages(locale: string): Promise<IMessageData[]> {
    const response: AxiosResponse<IApiResponse<{ pagedList: IApiMessageResponse[] }>> = await this.axios
      .get(`messages?locale=${encodeURIComponent(locale)}&pageNumber=1&pageSize=9`)
      .catch(() => Promise.reject());

    if (response?.data.data) {
      return response.data.data.pagedList.map((r) => mapApiMessage(r));
    }

    return Promise.reject();
  }

  async markAsRead(messageId: string) {
    const response: AxiosResponse<IApiResponse> = await this.axios
      .put(`messages/${messageId}/mark-as-read`)
      .catch(() => Promise.reject());

    return !!response.data.isSuccess;
  }
}
